import { render, staticRenderFns } from "./ContactFormPhone.vue?vue&type=template&id=51c5636c&"
import script from "./ContactFormPhone.vue?vue&type=script&lang=js&"
export * from "./ContactFormPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports